import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Button, useShowController } from "react-admin";
import useNotify from "../../unit/useNotify";
import { Tooltip } from "@mui/material";
import { Link, number } from "react-admin";
import CustomArrowCircleLeftSharpIcon from "../../unit/CustomArrowCircleLeftSharpIcon";

const CustomerActions = ({ ...props }) => {
  const paramAppId = props.userId;
  let userId = "";
  let record = props.record;

  if (paramAppId != undefined && record != undefined) {
    userId = paramAppId;
  } else {
    const controllerProps = useShowController();
    record = controllerProps.record;
    userId = record ? record.id : "";
  }

  const [isLoading, setIsLoading] = useState(true);
  const { success, warning, error, info } = useNotify();

  useEffect(() => {
    if (userId) {
      setIsLoading(false);
    }
  }, [userId]);

  if (isLoading) {
    return <Typography>User Action Loading...</Typography>;
  }
  if (record == undefined) {
    return <Typography>User Action Loading...</Typography>;
  }

  const handleClick = () => {
    info("click button");
  };

  const userType = record.userType;
  return (
    <Grid container id={"bottomactionbar-customer-summary-" + userId}>
      <Grid item>
        <Tooltip title="Return to Customers Lists" placement="left">
          <span className="customer-back-link">
            <Link to={`/customers?filter={"status":"${userType}"}`}>
              <CustomArrowCircleLeftSharpIcon />
            </Link>
          </span>
        </Tooltip>
      </Grid>
      <Grid item xs>
        <Grid container justifyContent="flex-end" spacing={1}>
          <Button
            label="Email"
            variant="contained"
            size="medium"
            color="primary"
            sx={{ width: "120px" }}
            onClick={handleClick}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomerActions;
